/**
 * @file checkbox.component.tsx
 * @description Form-control обертка для работы с UI Checkbox компонентом в react-hook-form
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, react-hook-form, @components/ui/base/checkbox]
 * @related-files [@components/ui/base/checkbox/checkbox.tsx]
 */

import { Checkbox as UICheckbox } from '@components/ui/base/checkbox';
import { Controller, Control } from 'react-hook-form';

/**
 * Props для form-control компонента Checkbox с интеграцией react-hook-form
 */
interface ICheckbox extends Omit<React.ComponentProps<typeof UICheckbox>, 'onChange' | 'value'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
}

export const Checkbox = ({ control, name, ...props }: ICheckbox) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <UICheckbox onChange={field.onChange} value={field.value} {...props} />
            )}
        />
    );
};
